import { generatePath } from "react-router-dom";
import { MainRoutes, SignUpRoutes } from "@router/route-params";

/** Name of the different paths in the app  */
export enum EAppRoutes {
  Login = "Login",
  SignupTrial = "SignupTrial",
  SignupInvited = "SignupInvited",
  ResendEmail = "ResendEmail",
  UserModule = "UserModule",
  ResetPassword = "ResetPassword",
  PasswordRecovery = "PasswordRecovery",
  ProviderLogin = "ProviderLogin",
  Logout = "Logout",
  VerifyEmail = "VerifyEmail",
  SsoLogin = "SsoLogin",
}

/** List of routes available in the app */
export const AppRoutes: Record<EAppRoutes, string> = {
  /** The route of login page */
  [EAppRoutes.Login]: `${MainRoutes.root}/${MainRoutes.login}`,

  /** The route of the signup flow when starting a free trial */
  [EAppRoutes.SignupTrial]: `${MainRoutes.root}/${MainRoutes.signup}/${SignUpRoutes.trial}`,

  /** The route of the signup flow when getting invited to a workspace */
  [EAppRoutes.SignupInvited]: `${MainRoutes.root}/${MainRoutes.signup}/${SignUpRoutes.invited}`,

  /** The resend verification email route */
  [EAppRoutes.ResendEmail]: `${MainRoutes.root}/${MainRoutes.resendEmail}`,

  /** The route after being redirected from the user module */
  [EAppRoutes.UserModule]: `${MainRoutes.root}/${MainRoutes.userModule}`,

  /** The route is used to reset a password when the user forgot it. */
  [EAppRoutes.ResetPassword]: `${MainRoutes.root}/${MainRoutes.resetPassword}`,

  /** The route is used to recover a password when the user forgot it. */
  [EAppRoutes.PasswordRecovery]: `${MainRoutes.root}/${MainRoutes.passwordRecovery}`,

  /** The route is used to either login into an specific 3rd party provider or select a provider to login */
  [EAppRoutes.ProviderLogin]: `${MainRoutes.root}/${MainRoutes.providerLogin}`,

  /** The route is used to logout the current user */
  [EAppRoutes.Logout]: `${MainRoutes.root}/${MainRoutes.logout}`,

  /** The route is used to verify the user's email address */
  [EAppRoutes.VerifyEmail]: `${MainRoutes.root}/${MainRoutes.verifyEmail}`,

  /** The route to login using a custom SSO provider */
  [EAppRoutes.SsoLogin]: `${MainRoutes.root}/${MainRoutes.ssoLogin}`,
};

/**
 * Generates the login route
 */
export function generateLoginRoute(): string {
  return generatePath(AppRoutes.Login);
}

/**
 * Generates the signup trial route
 */
export function generateTrialSignupRoute(): string {
  return generatePath(AppRoutes.SignupTrial);
}

/**
 * Generates the resend verification email route
 */
export function generateResendEmailRoute(): string {
  return generatePath(AppRoutes.ResendEmail);
}

/** Generates a route given the app route enum */
export function generateRoute(route: EAppRoutes): string {
  return generatePath(AppRoutes[route]);
}
